import { Component, Input, OnInit } from '@angular/core';
import { UtilService } from '../../shared/services';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {
  @Input() config;

  DEFAUL_CONFIG = {
    title: 'Testimonials',
    cause: 'medical',
    testimonials: []
  };

  breakpoints = {
    767: { perView: 1, gap: 30, autoplay: 4000, animationDuration: 1500 }
  };

  selectedDonor;
  selectedIndex;

  constructor(
    public utilService: UtilService
  ) { }

  ngOnInit() {
    this.config = { ...this.DEFAUL_CONFIG, ...this.config };
    this.selectedIndex = this.utilService.isMobile() ? 0 : 1;
    this.selectedDonor = this.config.testimonials[this.selectedIndex];
  }

  selectDonor(donor) {
    if (!this.utilService.isMobile()) {
      this.selectedDonor = donor;
    }
  }

  swiped(e) {
    if (e.direction === '>') {
      this.selectedIndex++;
    } else if (e.direction === '<') {
      this.selectedIndex--;
    }

    if (this.selectedIndex >= this.config?.testimonials.length) {
      this.selectedIndex = 0;
    } else if (this.selectedIndex < 0) {
      this.selectedIndex = this.config?.testimonials.length - 1;
    }

    this.selectedDonor = this.config?.testimonials[this.selectedIndex];
  }

}
